module.exports = __webpack_public_path__ + "static/img/banner-1.e2823589.jpg";